import React from 'react';

export default function EmptyState({ text = 'No data' }) {
  return (
    <div className="ca-empty-state" role="status">
      {text}
    </div>
  );
}
